export default "__VITE_ASSET__Dqoam$cC__"